import { AnnotationTool } from 'substance'

class BoldTool extends AnnotationTool {}

export default BoldTool
